<script>
	import { Table, DropdownItem } from "@sveltestrap/sveltestrap";
	import Pagination from "../../../components/CustomPaginate/Pagination.svelte";
	import CustomModal from "../../../components/CustomModal/CustomModal.svelte";
	import LoaderContainer from "../../../components/Loader/LoaderContainer.svelte";
	import { modalOpen, userId, fetchGroupModal } from "../../../store/store";
	import { convert } from "../../../services/helpers";
	import { navigate } from "svelte-routing";
	import TableDropdown from "../../../components/TableDropdown/TableDropdown.svelte";

	export let data;
	export let handleUserStatus;

	let dataGroup;
	const handleAssignGroup = async (id) => {
		modalOpen.set(true);
		fetchGroupModal.set(true);
		userId.set(id);
	};
</script>

<LoaderContainer>
	<Table responsive hover>
		<thead>
			<tr>
				<th>Name</th>
				<th>Mobile No.</th>
				<th>Driving Licence No.</th>
				<th>Joined Date</th>
				<th>Status</th>
				<th>Actions</th>
			</tr>
		</thead>
		<tbody>
			{#each data as { userId, fullName, countryCode, mobileNumber, drivingLicenceNumber, joinedDate, status, totalPages, drivingLicenseExpiry }}
				<tr>
					<td>
						<p>
							<!-- svelte-ignore a11y-click-events-have-key-events -->
							<span
								class="link link-text"
								on:click={() =>
									navigate(
										`/account/account-management/edit/${userId}`
									)}
							>
								{fullName}
							</span>
						</p>
					</td>
					<td>
						{countryCode}{mobileNumber}
					</td>
					<td>
						{#if drivingLicenceNumber == undefined}
							<p class="mx-5">-</p>
						{:else}
							{drivingLicenceNumber}
						{/if}
					</td>
					<td>
						{convert(joinedDate)}
					</td>

					<td>
						{#if status === 0}
							<p class="status-bar status-bar-1">Active</p>
						{:else if status === 1}
							<p class="status-bar status-bar-3">Inactive</p>
						{:else if status === 2}
							<p class="status-bar status-bar-3">Banned</p>
						{:else if status === 3}
							<p class="status-bar status-bar-2">Pending</p>
						{/if}
					</td>
					<td
						><TableDropdown>
							<DropdownItem
								on:click={() =>
									navigate(
										`/account/account-management/edit/${userId}`
									)}>Edit</DropdownItem
							>
							<DropdownItem
								on:click={() => handleAssignGroup(userId)}
								>Assign group</DropdownItem
							>
							{#if status === 0}
								<DropdownItem
									on:click={() => handleUserStatus(userId, 1)}
									>Set as Inactive</DropdownItem
								>
							{:else if status === 1}
								<DropdownItem
									on:click={() => handleUserStatus(userId, 0)}
									>Set as Active</DropdownItem
								>
							{/if}
						</TableDropdown>
					</td>
				</tr>
			{/each}
		</tbody>
	</Table>
	{#if data.length === 0}
		<p class="text-center">No data to display</p>
	{/if}
	<Pagination totalRecord={data.length} />
	{#if $modalOpen}
		<CustomModal />
	{/if}
</LoaderContainer>
